module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-lg-2"
  }, [_c('va-box', {
    attrs: {
      "title": "Reports list",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h5', [_vm._v("Select Report:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportKey),
      expression: "reportKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.reports), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      },
      domProps: {
        "value": item['.key']
      }
    }, [_vm._v("\n            " + _vm._s(item.Name) + "\n          ")])
  })], 2)])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": _vm.selectedElm.text ? _vm.selectedElm.text : 'New Item',
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button",
      "value": "Add New Item"
    },
    on: {
      "click": function($event) {
        return _vm.addNewItem()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          Order:\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIndex),
      expression: "selectedIndex"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeOrder()
      }]
    }
  }, _vm._l((_vm.countItems), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          Section:\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSection),
      expression: "selectedSection"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeSection()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "header"
    }
  }, [_vm._v("header")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "body"
    }
  }, [_vm._v("body")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "page_footer"
    }
  }, [_vm._v("page_footer")])])]), _vm._v(" "), _vm._l((_vm.selectedElmItems), function(item) {
    return (_vm.selectedElmItems) ? _c('div', {
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n          " + _vm._s(item.Key) + ": "), (item.Type === 'range') ? _c('b', [_vm._v(_vm._s(item.Value))]) : _vm._e(), _vm._v(" "), (item.Key === 'type') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Value),
        expression: "item.Value"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "Value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "text"
      }
    }, [_vm._v("text")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "image"
      }
    }, [_vm._v("image")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "box"
      }
    }, [_vm._v("box")])]) : (item.Key === 'align') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Value),
        expression: "item.Value"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "Value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.itemUpdate(item)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "left"
      }
    }, [_vm._v("left")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "center"
      }
    }, [_vm._v("center")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "right"
      }
    }, [_vm._v("right")])]) : ((item.Type) === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Value),
        expression: "item.Value"
      }],
      attrs: {
        "step": item.Range.Step,
        "min": item.Range.Min,
        "max": item.Range.Max,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.Value) ? _vm._i(item.Value, null) > -1 : (item.Value)
      },
      on: {
        "change": [function($event) {
          var $$a = item.Value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "Value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "Value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "Value", $$c)
          }
        }, function($event) {
          return _vm.itemUpdate(item)
        }]
      }
    }) : ((item.Type) === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Value),
        expression: "item.Value"
      }],
      attrs: {
        "step": item.Range.Step,
        "min": item.Range.Min,
        "max": item.Range.Max,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(item.Value, null)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(item, "Value", null)
        }, function($event) {
          return _vm.itemUpdate(item)
        }]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Value),
        expression: "item.Value"
      }],
      attrs: {
        "step": item.Range.Step,
        "min": item.Range.Min,
        "max": item.Range.Max,
        "type": item.Type
      },
      domProps: {
        "value": (item.Value)
      },
      on: {
        "change": function($event) {
          return _vm.itemUpdate(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Value", $event.target.value)
        }
      }
    })]) : _vm._e()
  })], 2)])], 1), _vm._v(" "), (_vm.report) ? _c('column', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.Name),
      expression: "report.Name"
    }],
    staticClass: "pull-left form-control",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Report Name"
    },
    domProps: {
      "value": (_vm.report.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "Name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.orientationItems), function(item) {
    return _c('div', {
      staticClass: "pull-left tree-content tree--small left",
      staticStyle: {
        "margin-left": "20px",
        "width": "130px"
      },
      on: {
        "click": function($event) {
          _vm.orientation = item.name
        }
      }
    }, [_c('i', {
      class: ['tree-checkbox', _vm.orientation === item.name ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('i', {
      class: [item.icon, item.class]
    }), _vm._v("   " + _vm._s(item.name) + "\n          ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [(_vm.$root.isAdmin) ? _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Edit Report"
    },
    on: {
      "click": _vm.saveReport
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    staticStyle: {
      "font-size": "18px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Save as PDF"
    },
    on: {
      "click": _vm.cancelReport
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "18px"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "min-height": "450px",
      "height": "100%",
      "padding": "10px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "report-designer-container"
  }, [_c('div', {
    staticStyle: {
      "width": "11in",
      "height": "8.5in",
      "background-color": "#dfdfdf",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fafafa",
      "position": "absolute",
      "top": "0.5in",
      "left": "0.5in",
      "bottom": "0.5in",
      "right": "0.5in"
    }
  }, [_vm._l((_vm.report.Definition.header.elements), function(elm, index) {
    return _c('div', {
      staticClass: "reportHeader",
      on: {
        "click": function($event) {
          return _vm.showElement(index, 'header', elm)
        }
      }
    }, [_vm._l((_vm.handles), function(handle) {
      return _c('div', {
        class: ['handle', 'handle-' + handle],
        on: {
          "mousedown": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.handleDown(handle, $event)
          }
        }
      })
    }), _vm._v(" "), (elm.type === 'box') ? _c('div', {
      style: (_vm.GetStyle(elm)),
      attrs: {
        "id": 'header' + 'Elm' + index
      }
    }) : _vm._e(), _vm._v(" "), (elm.type === 'text') ? _c('div', {
      style: (_vm.GetStyle(elm)),
      attrs: {
        "id": 'header' + 'Elm' + index
      }
    }, [_vm._v(_vm._s(elm.text))]) : _vm._e(), _vm._v(" "), (elm.type === 'image') ? _c('img', {
      style: (_vm.GetStyle(elm)),
      attrs: {
        "id": 'header' + 'Elm' + index,
        "src": elm.url
      }
    }) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "reportBody",
    staticStyle: {
      "position": "absolute",
      "top": "1.3in",
      "left": "0in",
      "bottom": "0.50in",
      "right": "0in"
    }
  }, _vm._l((_vm.report.Definition.body.elements), function(elm, index) {
    return _c('div', {
      style: ({
        border: '1px #ccc dotted',
        position: 'absolute',
        top: elm.top + 'in',
        left: elm.left + 'in',
        width: elm.width + 'in',
        height: elm.height + 'in',
        backgroundColor: elm.background_color
      }),
      attrs: {
        "id": 'body' + 'Elm' + index
      },
      on: {
        "click": function($event) {
          return _vm.showElement(index, 'body', elm)
        }
      }
    }, [_vm._v(_vm._s(elm.text))])
  }), 0), _vm._v(" "), _vm._l((_vm.report.Definition.page_footer.elements), function(elm, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.report.Definition.page_footer.visible),
        expression: "report.Definition.page_footer.visible"
      }],
      staticClass: "reportFooter",
      style: ({
        position: 'absolute',
        left: '0in',
        bottom: '0in',
        right: '0in',
        heigth: _vm.report.Definition.page_footer.height + 'in'
      }),
      on: {
        "click": function($event) {
          return _vm.showElement(index, 'page_footer', elm)
        }
      }
    }, [(elm.type === 'box') ? _c('div', {
      style: (_vm.GetFooterStyle(elm)),
      attrs: {
        "id": 'page_footer' + 'Elm' + index
      }
    }) : _vm._e(), _vm._v(" "), (elm.type === 'text') ? _c('div', {
      style: (_vm.GetFooterStyle(elm)),
      attrs: {
        "id": 'page_footer' + 'Elm' + index
      }
    }, [_vm._v(_vm._s(elm.text))]) : _vm._e(), _vm._v(" "), (elm.type === 'image') ? _c('img', {
      style: (_vm.GetFooterStyle(elm)),
      attrs: {
        "id": 'page_footer' + 'Elm' + index,
        "src": elm.url
      }
    }) : _vm._e()])
  })], 2)])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf0cf316!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportEditorAdmin.vue
// module id = 755
// module chunks = 0